import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const BookReact = () => {
  useEffect(() => {
    document.title = "Book App — Viktoriia Yashkina";
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.75, ease: "easeOut" }}
      className="body"
    >
      <div className="portfolioContainer">
        <div className="pt-12">
          <Link to="/portfolio" className="backLink">
            Back
          </Link>
          <h2 className="h2PortfolioProject">portfolio — book App</h2>{" "}
          <div className="portfolioContext">
            <div className="textContainer">
              <p>
                Since my coding learning is too slow (I was taking on too much),
                I arranged a personal coding marathon for a whole week. The main
                goal - do one project per day from 28.06.2023 to 04.07.2023.
              </p>
              <p>
                This is my first project in this marathon - Book Application.
              </p>
              <p className="font-bold">Technology & Resources Used:</p>
              <p>01. React, HTML5, and CSS3</p>
              <p>
                02. Google Books API from{" "}
                <a
                  href="https://developers.google.com/"
                  className="allLinks"
                  rel="noreferrer"
                  target="_blank"
                >
                  Google for Developers
                </a>
              </p>
              <p>03. Vercel for hosting</p>
              <p>04. Google Fonts & Google Icons</p>
              <p className="font-bold">Main Links:</p>
              <p>
                01.{" "}
                <a
                  href="https://book-app-react.vercel.app/"
                  className="allLinks"
                  rel="noreferrer"
                  target="_blank"
                >
                  Live Preview
                </a>
              </p>
              <p>
                02.{" "}
                <a
                  href="https://github.com/viktoriia-yash/book-app-react"
                  className="allLinks"
                  rel="noreferrer"
                  target="_blank"
                >
                  GitHub
                </a>
              </p>
            </div>
            <div className="max-w-[300px]"></div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default BookReact;
